import React, { useState } from "react";
import Swal from "sweetalert2";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import { submitContactForm } from "../../../utils/submitContactForm";
import { Color } from "../../../utils/theme";

function Contact() {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const fd = new FormData(form);
    const name = String(fd.get("name") ?? "").trim();
    const phone = String(fd.get("phone") ?? "").trim();
    const email = String(fd.get("email") ?? "").trim();
    const message = String(fd.get("message") ?? "").trim();

    setSubmitting(true);
    try {
      await submitContactForm({
        nom_complet: name,
        email,
        tel: phone,
        message,
        subject: "Message — formulaire Kazamansa",
        source: window.location.hostname || "",
      });

      await Swal.fire({
        icon: "success",
        title: "Message envoyé",
        text: "Nous vous répondrons dès que possible.",
        confirmButtonColor: Color.themeColor,
      });
      form.reset();
    } catch {
      await Swal.fire({
        icon: "error",
        title: "Envoi impossible",
        text: "L'envoi a échoué. Veuillez réessayer dans quelques instants.",
        confirmButtonColor: Color.themeColor,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content pb-5 contact-page-content">
        <section
          className="contact-page-form-section"
          aria-labelledby="contact-form-heading"
        >
          <div className="contact-page-form-section__inner">
            <div className="contact-form-maquette">
              <h1
                className="contact-form-maquette__title"
                id="contact-form-heading"
              >
                Formulaire de contact
              </h1>
              <form
                className="contact-form-maquette__form"
                onSubmit={handleSubmit}
                noValidate
              >
                <input
                  type="text"
                  name="name"
                  className="contact-form-maquette__field"
                  placeholder="Nom et prénom"
                  autoComplete="name"
                  required
                  aria-required
                />
                <input
                  type="tel"
                  name="phone"
                  className="contact-form-maquette__field"
                  placeholder="Téléphone"
                  autoComplete="tel"
                />
                <input
                  type="email"
                  name="email"
                  className="contact-form-maquette__field"
                  placeholder="Email"
                  autoComplete="email"
                  required
                  aria-required
                />
                <textarea
                  name="message"
                  className="contact-form-maquette__field contact-form-maquette__field--message"
                  placeholder="Message"
                  rows={8}
                  required
                  aria-required
                />
                <div className="contact-form-maquette__actions">
                  <button
                    type="submit"
                    className="contact-form-maquette__submit"
                    disabled={submitting}
                  >
                    {submitting ? "ENVOI…" : "ENVOYER"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
      <FrontFooter />
    </div>
  );
}

export default Contact;
